import { NgModule } from '@angular/core';
import { ASCIIPipe } from './common/ascii.pipe';
import { StorageService } from './services/storage.service';
import { MailingService } from './services/mailing.service';
import { RmsService } from './services/rms.service';

@NgModule({

  declarations: [
    ASCIIPipe,
  ],

  providers: [
    MailingService,
    StorageService,
    RmsService,
    ASCIIPipe
  ]
})
export class JvCommonModule { }
